import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '../main.css';
export const createPrivateNetworkDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.privateNetworkRegion',
        popover: {
          title: 'Network Actions Overview',
          description:
            'This section provides options for managing virtual machines in this network region. Actions may include starting, stopping, or rebooting VMs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkName',
        popover: {
          title: 'Network Name',
          description:
            'Here you can view and edit the name of your private network. The network name helps identify and manage different network segments.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkSubnet',
        popover: {
          title: 'Subnet Configuration',
          description:
            'This section displays the subnet settings for your private network. Ensure that your subnet configuration aligns with your network architecture.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkSubnetMask',
        popover: {
          title: 'Subnet Mask',
          description:
            'The subnet mask defines the network range within your private network. Check that it is correctly configured for proper network segmentation.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkGateway',
        popover: {
          title: 'Network Gateway',
          description:
            'The gateway is used for routing traffic between different networks. Make sure the gateway settings are accurate for seamless network connectivity.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkDns1',
        popover: {
          title: 'Primary DNS Server',
          description:
            'This field allows you to set the primary DNS server for your network. DNS servers resolve domain names into IP addresses for network communication.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkDns2',
        popover: {
          title: 'Secondary DNS Server',
          description:
            'Configure the secondary DNS server here. This server acts as a backup to ensure DNS resolution continues if the primary server fails.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkDescription',
        popover: {
          title: 'Network Description',
          description:
            'Provide a description for your private network to document its purpose and configuration details. This helps in managing and understanding the network setup.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default createPrivateNetworkDriverObj;
